module.exports = __webpack_public_path__ + "static/media/icon-checkmark--gray.55724dc2.svg";